(function () {
  'use strict';

  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format(Number(cents || 0) / 100);

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function toast(text) {
    const element = $('#eb-toast');
    if (!element) return;
    element.textContent = text;
    element.classList.add('is-visible');
    window.setTimeout(() => element.classList.remove('is-visible'), 2600);
  }

  function initMenu() {
    const menu = $('[data-mobile-menu]');
    const open = $('[data-menu-open]');
    const close = $('[data-menu-close]');
    if (!menu || menu.dataset.initialized === 'true') return;
    menu.dataset.initialized = 'true';
    open?.addEventListener('click', () => { menu.hidden = false; });
    close?.addEventListener('click', () => { menu.hidden = true; });
  }

  function initTicketProducts(root = document) {
    $$('[data-ticket-product]', root).forEach((product) => {
      if (product.dataset.initialized === 'true') return;
      product.dataset.initialized = 'true';
      let firstAvailableOpened = false;

      $$('[data-variant-card]', product).forEach((card) => {
        const head = $('[data-variant-toggle]', card);
        const body = $('.eb-ticket-card__body', card);
        if (!head || !body) return;

        const setOpen = (open) => {
          body.hidden = !open;
          head.setAttribute('aria-expanded', String(open));
          card.classList.toggle('is-open', open);
          if (open && card.dataset.stockMessage) {
            const scope = product.closest('.shopify-section') || document;
            const stock = $('[data-stock-copy]', scope);
            if (stock) stock.textContent = card.dataset.stockMessage;
          }
        };

        head.addEventListener('click', () => {
          const shouldOpen = body.hidden;
          $$('[data-variant-card]', product).forEach((otherCard) => {
            const otherBody = $('.eb-ticket-card__body', otherCard);
            const otherHead = $('[data-variant-toggle]', otherCard);
            if (otherBody) otherBody.hidden = true;
            if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
            otherCard.classList.remove('is-open');
          });
          setOpen(shouldOpen);
        });

        $$('[data-qty]', card).forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            $$('[data-qty]', card).forEach((item) => item.classList.remove('is-active'));
            button.classList.add('is-active');
            const quantity = Number(button.dataset.qty || 1);
            const price = Number(card.dataset.price || 0);
            const quantityInput = $('[data-form-quantity]', card);
            const total = $('[data-total]', card);
            if (quantityInput) quantityInput.value = quantity;
            if (total) total.textContent = money(quantity * price);
          });
        });

        $('form', card)?.addEventListener('submit', () => toast('Ajout de vos places à la réservation…'));

        if (!firstAvailableOpened && !card.classList.contains('is-sold-out')) {
          setOpen(true);
          firstAvailableOpened = true;
        }
      });
    });
  }

  function initStickyButton(root = document) {
    $$('[data-scroll-variants]', root).forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => $('.eb-ticket-variants')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    });
  }

  function initCartControls(root = document) {
    $$('[data-cart-minus]', root).forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = button.parentElement?.querySelector('input');
        if (!input) return;
        input.value = Math.max(0, Number(input.value) - 1);
        input.form?.submit();
      });
    });

    $$('[data-cart-plus]', root).forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = button.parentElement?.querySelector('input');
        if (!input) return;
        input.value = Number(input.value) + 1;
        input.form?.submit();
      });
    });
  }

  function initCartTimers(root = document) {
    $$('[data-cart-timer]', root).forEach((timer) => {
      if (timer.dataset.initialized === 'true') return;
      timer.dataset.initialized = 'true';
      const minutes = Number(timer.dataset.minutes || 5);
      const key = 'eb-cart-reservation-end';
      let end = 0;
      // Storage may be unavailable in a restricted browser or theme preview.
      // A storage error must not abort the other theme initializers.
      try { end = Number(window.localStorage.getItem(key)); } catch (_) {}
      if (!Number.isFinite(end) || !end || end < Date.now()) {
        end = Date.now() + minutes * 60000;
        try { window.localStorage.setItem(key, String(end)); } catch (_) {}
      }
      const output = $('[data-cart-timer-value]', timer);
      const tick = () => {
        const left = Math.max(0, end - Date.now());
        const mins = Math.floor(left / 60000);
        const secs = Math.floor((left % 60000) / 1000);
        if (output) output.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      };
      tick();
      window.setInterval(tick, 1000);
    });
  }

  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((element) => {
      if (element.dataset.initialized === 'true') return;
      element.dataset.initialized = 'true';
      let left = Number(element.dataset.countdown || 30) * 60;
      const output = $('[data-countdown-value]', element);
      const tick = () => {
        const mins = Math.floor(left / 60);
        const secs = left % 60;
        if (output) output.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
        left = Math.max(0, left - 1);
      };
      tick();
      window.setInterval(tick, 1000);
    });
  }

  function initEventCollections(root = document) {
    $$('[data-event-collection]', root).forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const source = $('[data-event-source]', section);
      const groupsContainer = $('[data-event-groups]', section);
      const sectionId = section.dataset.sectionId;
      const select = document.querySelector(`#CitySelect-${CSS.escape(sectionId)}`);
      if (!source || !groupsContainer) return;

      const cards = $$('[data-event-card]', source);
      if (!cards.length) return;

      const cityOrder = [];
      const grouped = new Map();

      cards.forEach((card) => {
        const city = card.dataset.city || 'Dates disponibles';
        if (!grouped.has(city)) {
          grouped.set(city, []);
          cityOrder.push(city);
        }
        grouped.get(city).push(card);
      });

      cityOrder.forEach((city) => {
        grouped.get(city).sort((a, b) => String(a.dataset.date || '').localeCompare(String(b.dataset.date || '')));

        if (select) {
          const option = document.createElement('option');
          option.value = city;
          option.textContent = city;
          select.appendChild(option);
        }

        const group = document.createElement('section');
        group.className = 'eb-event-group';
        group.id = `city-${sectionId}-${slugify(city)}`;
        group.innerHTML = `
          <h2 class="eb-event-city">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" fill="none" stroke="currentColor"></path><circle cx="12" cy="10" r="2" fill="none" stroke="currentColor"></circle></svg>
          </h2>
          <div class="eb-event-grid"></div>`;

        $('.eb-event-city', group).appendChild(document.createTextNode(city));
        const grid = $('.eb-event-grid', group);
        grouped.get(city).forEach((card) => grid.appendChild(card));
        // Keep any page navigation after the city groups, not above the results.
        groupsContainer.insertBefore(group, groupsContainer.querySelector('nav'));
      });

      source.remove();

      select?.addEventListener('change', () => {
        if (!select.value) return;
        document.getElementById(`city-${sectionId}-${slugify(select.value)}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initPosterFallbacks(root = document) {
    $$('[data-product-poster]', root).forEach((image) => {
      if (image.dataset.initialized === 'true') return;
      image.dataset.initialized = 'true';
      const markLoaded = () => {
        image.hidden = false;
        image.style.removeProperty('display');
        const frame = image.closest('.eb-product__media-frame');
        frame?.classList.remove('is-empty');
        frame?.classList.add('is-loaded');
      };
      const markFailed = () => {
        image.hidden = true;
        // The existing display:block rule can override the browser's [hidden].
        image.style.display = 'none';
        const frame = image.closest('.eb-product__media-frame');
        frame?.classList.remove('is-loaded');
        frame?.classList.add('is-empty');
      };
      image.addEventListener('load', markLoaded);
      image.addEventListener('error', markFailed);
      if (image.complete) {
        if (image.naturalWidth > 0) markLoaded();
        else markFailed();
      }
    });
  }

  function init(root = document) {
    initMenu();
    initTicketProducts(root);
    initStickyButton(root);
    initCartControls(root);
    initCartTimers(root);
    initCountdowns(root);
    initEventCollections(root);
    initPosterFallbacks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
